"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var string_serialiser_1 = require("./../serialisers/string-serialiser");
var service_definition_1 = require("./../services/service-definition");
var create_topic_view_result_serialiser_1 = require("./../services/topic-views/create-topic-view-result-serialiser");
var list_topic_views_result_serialiser_1 = require("./../services/topic-views/list-topic-views-result-serialiser");
var named_topic_view_specification_serialiser_1 = require("./../services/topic-views/named-topic-view-specification-serialiser");
exports.CREATE_TOPIC_VIEW = {
    id: 138,
    request: named_topic_view_specification_serialiser_1.NamedTopicViewSpecificationSerialiser,
    response: create_topic_view_result_serialiser_1.CreateTopicViewResultSerialiser
};
exports.REMOVE_TOPIC_VIEW = {
    id: 139,
    request: string_serialiser_1.StringSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.LIST_TOPIC_VIEWS = {
    id: 141,
    request: service_definition_1.NullSerialiser,
    response: list_topic_views_result_serialiser_1.ListTopicViewsResultSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-views-services.js
// module id = 1388
// module chunks = 1